import { useTitle } from '@/hooks/useTitle';
import { Flex } from '@/layouts/Flex';
import { Link } from 'react-router';
import styles from './styles.module.scss';

export function AboutPage() {
  useTitle('DienTEA | Acerca del proyecto');

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        Acerca del <em>proyecto</em>
      </h2>
      <div className={styles.divider} />

      {/* Card 1 */}
      <div className={`${styles.card} ${styles.cardAnim1}`}>
        <div className={`${styles.cardAccent} ${styles.accentBlue}`}>🦷</div>
        <p>
          En los últimos años, muchas familias recurren a Internet y, especialmente, a YouTube™️ para buscar información
          sobre cómo preparar a sus hijos para la primera visita al dentista. Esto es aún más frecuente cuando se trata
          de niños con Trastorno del Espectro Autista (TEA), ya que las visitas odontológicas pueden generar ansiedad,
          incertidumbre y muchas preguntas en casa.
        </p>
      </div>

      {/* Card 2 */}
      <div className={`${styles.card} ${styles.cardAnim2}`}>
        <div className={`${styles.cardAccent} ${styles.accentRed}`}>👩‍⚕️</div>
        <p>
          La Dra. Nuria Pérez-Guzmán y la Dra. María Pilar Pecci-Lloret, odontopediatras con experiencia en el manejo de
          pacientes con necesidades especiales, se encontraron repetidamente con una situación muy común en consulta:
          padres preocupados que llegaban con dudas basadas en vídeos que habían visto en redes sociales, algunos de
          ellos útiles… pero otros con información incompleta o incluso errónea.
        </p>
        <blockquote className={styles.highlightText}>
          A partir de esta problemática surgió la idea de crear una herramienta fiable y accesible para las familias.
        </blockquote>
      </div>

      {/* H3 section */}
      <h3 className={styles.subtitle}>¿Qué pretende esta aplicación?</h3>

      <div className={styles.sectionBlock}>
        {/* List card */}
        <div className={styles.listCard}>
          <p>
            Esta app nace con el objetivo de ofrecer un espacio seguro donde los padres puedan encontrar vídeos
            seleccionados y organizados sobre la visita dental en niños, especialmente aquellos con TEA. Todo el
            contenido está etiquetado según:
          </p>
          <Flex flexWrap='wrap' gap={8} style={{ marginTop: '1rem' }}>
            {['tipo de vídeo', 'idioma', 'autor o creador del material', 'finalidad educativa'].map((item) => (
              <span key={item} className={styles.listChip}>
                <span className={styles.chipCheck}>✓</span>
                {item}
              </span>
            ))}
          </Flex>
        </div>

        {/* Card 3 */}
        <div className={`${styles.card} ${styles.cardAnim3}`}>
          <div className={`${styles.cardAccent} ${styles.accentGray}`}>🖼️</div>
          <p>
            Además, se han excluido aquellos vídeos que contienen información falsa o no basada en evidencia científica.
          </p>
          <p style={{ marginTop: '1rem' }}>
            Como complemento, la aplicación incorpora también pictogramas y apoyos visuales, diseñados para ayudar a los
            niños a anticipar la experiencia en el dentista, reducir la ansiedad y favorecer una visita más tranquila y
            positiva.
          </p>
        </div>
      </div>

      {/* Summary dark card */}
      <div className={styles.summaryCard}>
        <p>
          En definitiva, este proyecto busca unir la <strong>evidencia científica</strong>, la{' '}
          <strong>experiencia clínica</strong> y las <strong>herramientas visuales</strong> para acompañar a las
          familias en un momento tan importante como es la primera visita al dentista.
        </p>
      </div>

      <video src='videos/introduction.mp4' autoPlay={false} controls controlsList='nodownload' preload='auto' />

      <h3 className={styles.subtitle} style={{ marginTop: 26 }}>
        Otros colaboradores
      </h3>

      <div className={styles.collaboratorsContainer}>
        <Link target='_blank' to='https://josetomashl.github.io/' className={styles.collaboratorCard}>
          <img src='images/software-engineer.webp' alt='José Tomás' loading='lazy' />
          <h4>José Tomás Hernandez</h4>
          <p>Software Engineer</p>
        </Link>
        <Link target='_blank' to='https://www.instagram.com/moodtivadas/' className={styles.collaboratorCard}>
          <img src='images/moodtivadas-vertical.png' alt='Moodtivadas' loading='lazy' />
          <h4>Moodtivadas</h4>
          <p>Design & Branding</p>
        </Link>
      </div>
    </div>
  );
}
